import CONFIG from '@/config'
import Cookies from 'js-cookie'
let DOMAIN = process.env.NODE_ENV == 'production' ? '.starsgames.cn' : '.192.168.101.28'
class CookieProxy {
    constructor() {
        this.prefix = ''
        this.baseParams = {
            expires: 7,
            path: '/',
            domain: DOMAIN
            // Secure : true,
            // SameSite : 'none',
        }
    }



    getAll () {
        return Cookies.get()
    }

    clearAll () {
        const keys = Object.keys(this.getAll())
        keys.forEach(key => {
            this.remove(key, false)
        })
    }

    get (key, hasPrefix = true) {
        const keyStr = hasPrefix ? this.prefix + '' + key : key
        let value = Cookies.get(keyStr)
        // 如果JSON.parse能够转换成功；并且转换后的类型为object 且不等于 null，那么这个字符串就是JSON格式的字符串。
        function isJSON_test (str) {
            if (typeof str == 'string') {
                try {
                    var obj = JSON.parse(str);
                    return obj;
                } catch (e) {
                    return value;
                }
            }
        }
        return isJSON_test(value)
    }

    set (key, value, params) {
        const options = params === undefined ? this.baseParams : params
        const keyStr = this.prefix + '' + key
        return Cookies.set(keyStr, JSON.stringify(value), options)
    }

    remove (key, hasPrefix = true) {
        const keyStr = !hasPrefix ? key : this.prefix + '' + key
        return Cookies.remove(keyStr, {
            path: '/',
            domain: DOMAIN
        })
    }
}
const cookies = new CookieProxy()
export default cookies

